import { ModalVelocityConfig } from '@/components/ui/modal-velocity-config'
import { CampaignContextProvider } from '@/contexts/campaign-context-provider'
import { ConfigContextProvider } from '@/contexts/config-context'
import { userServiceInstance } from '@/services/user.service'
import { userAtom } from '@/store/atoms/user.atom'
import { Outlet, createRootRoute, useRouter } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { ApolloProvider } from "@apollo/client/react";
import { client } from '@/configs/apollo-client'
//@ts-expect-error
import terminal from 'virtual:terminal';
import { ModalAge } from '@/components/ui/modal-age'

export const Route = createRootRoute({
  component: RouteComponent,
  loader: async () => {
    const currentUser = userServiceInstance.me()

    return currentUser
  },
  shouldReload: true,
})

function RouteComponent() {
  const currentUser = Route.useLoaderData()
  const [, setUser] = useAtom(userAtom)
  const router = useRouter()
  terminal.log(`
    +---------------------------+
    |                           |
    |                           |
    |                           |
    |                           |
    |                           |
    |                           |
    +---------------------------+   
  `)
  useEffect(() => {
    if (!currentUser) return
    setUser(currentUser)
    if (navigator.userAgent.includes('Mobile')) {
      router.navigate({
        to: '/mobile/home'
      })
      return
    }
    router.navigate({
      to: '/desktop/home'
    })
  }, [])

  return (
    <ApolloProvider client={client}>
      <CampaignContextProvider>
        <ConfigContextProvider>
          <Outlet />
          <TanStackRouterDevtools />
          <ModalAge />
          <Toaster
            position="top-center"
            reverseOrder={false}
            containerStyle={{
              zIndex: 999999
            }}
          />
          <ModalVelocityConfig />
        </ConfigContextProvider>
      </CampaignContextProvider>
    </ApolloProvider>
  )
}